import { RegexValidator } from '../../../../../../ui/gzForm/validators/regex.validator';
import { ValidationResult } from '../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../utils/translator.helper';

export function extension(value: string): Promise<ValidationResult> {
  return RegexValidator(/^\.?[^\\:\*\?"<>| ]+$/, translateFn('Invalid extension'))(value);
}
